import React from 'react';

const features = [
  {
    iconClass: 'feat-icon-1',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0D5F64" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    ),
    title: 'Live Multiplayer',
    description:
      'Play with friends and family in real time. No waiting around, everyone draws and guesses together in the moment.',
  },
  {
    iconClass: 'feat-icon-2',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#219077" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        <line x1="9" y1="7" x2="16" y2="7" />
        <line x1="9" y1="11" x2="14" y2="11" />
      </svg>
    ),
    title: 'Word Categories',
    description:
      "Dozens of themed categories including animals, movies, food, and more. There's always something fun waiting to be drawn.",
  },
  {
    iconClass: 'feat-icon-3',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0D5F64" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <line x1="19" y1="8" x2="19" y2="14" />
        <line x1="22" y1="11" x2="16" y2="11" />
      </svg>
    ),
    title: 'Easy Invites',
    description:
      'Share a link or code to get anyone in. Getting your crew into a game takes seconds zero sign-up friction.',
  },
  {
    iconClass: 'feat-icon-4',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#FF6F61" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 19l7-7 3 3-7 7-3-3z" />
        <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
        <path d="M2 2l7.586 7.586" />
        <circle cx="11" cy="11" r="2" />
      </svg>
    ),
    title: 'Custom Categories',
    description:
      'Create your own word packs for inside jokes, study sessions, or themed parties. Make the game truly yours.',
  },
];

function Features() {
  return (
    <section className="features" id="features">
      <div className="wrap">
        <div className="section-head">
          <div className="section-pill">
            <span className="section-pill-dot"></span> Features
          </div>
          <h2 className="section-h2">Everything you need to play</h2>
          <p className="section-p">
            Simple to pick up, impossible to put down. Packed with features that
            make every session unforgettable.
          </p>
        </div>

        <div className="feat-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`feat-card reveal ${index > 0 ? `reveal-d${index}` : ''}`}
            >
              <div className={`feat-icon ${feature.iconClass}`}>
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;